import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, TextField } from "@mui/material";
import { forwardRef, useMemo } from "react";
import { MetadataInputProps } from "../metadata-input-index";
import { useTranslation } from "react-i18next";

export type LocalizedCreditsMetadataInfos = {
  cultureId: number;
  value: string | null;
  language: string;
  epNb?: number | null;
};

type LocalizedCreditsMetadataInfosIndexed = {
  index: number;
  data: LocalizedCreditsMetadataInfos;
};

const MetadataInputCreditsLocalized = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { t } = useTranslation();
  const { onChange, data, value, cultureId, epNb } = props;

  const getLocalizedValues = (): LocalizedCreditsMetadataInfosIndexed[] => {
    let array: LocalizedCreditsMetadataInfosIndexed[] = [];

    if (!cultureId)
      return (value as LocalizedCreditsMetadataInfos[]).map((data, index) => ({ index: index, data: data }));

    for (let i = 0; i < (value as LocalizedCreditsMetadataInfos[]).length; ++i) {
      if (
        value[i].cultureId &&
        value[i].cultureId === cultureId &&
        value[i].value &&
        value[i].epNb === epNb &&
        value[i].value !== null
      )
        array.push({ index: i, data: value[i] });
    }

    return array;
  };

  const localized = useMemo((): LocalizedCreditsMetadataInfosIndexed[] => {
    return getLocalizedValues();
  }, [value, cultureId, epNb]);

  return (
    <Autocomplete
      id={data.tagName!}
      options={[]}
      multiple
      freeSolo
      isOptionEqualToValue={(option) => value?.includes(option) || false}
      value={localized.map((v) => v.data.value)}
      getOptionLabel={(option) => option ?? ""}
      onChange={(e, value) => {
        let values: LocalizedCreditsMetadataInfos[] =
          value.length > 0
            ? value.map((stringValue) => ({
                cultureId: cultureId!,
                value: stringValue,
                language: "",
                epNb: epNb,
              }))
            : [
                {
                  cultureId: cultureId!,
                  value: null,
                  language: "",
                  epNb: epNb,
                },
              ];

        // Enable pushAndReplaceWhereCultureIds: means replace all values or add with given cultureIds
        onChange(
          values.length > 0 ? values : [{ cultureId: cultureId!, value: null, language: "", epNb: epNb }],
          data.id,
          undefined,
          [cultureId!]
        );
      }}
      popupIcon={<ExpandMoreRoundedIcon />}
      renderInput={(params) => (
        <TextField sx={{ mt: "-24px" }} placeholder={t("field:placeholder.enterCredits")} {...params} />
      )}
    />
  );
});

export default MetadataInputCreditsLocalized;
